import { COUNTRY_STATES } from '@/const/common';
import { StateCase } from '@/interfaces';

export const abbreviatedStates = (states: StateCase[]) => {
	const statesString =
		states
			?.map(
				(caseState) =>
					COUNTRY_STATES.find((state) => state.label === caseState.name)?.value
			)
			.join(', ') || '';
	return statesString;
};

export const formatStates = (
	states: StateCase[] | undefined,
	isDesktopOrLaptop?: boolean
) => {
	if (!states) {
		return {
			statesToList: '',
			statesToModal: [],
		};
	}
	let formatStates = states?.map(
		(caseState) =>
			COUNTRY_STATES.find((state) => state.label === caseState.name)?.value
	);

	formatStates = Array.from(new Set(formatStates));
	const moreThanFive = formatStates && formatStates.length > 5;
	const statesToList = moreThanFive
		? formatStates
				.filter((_item, index) => (isDesktopOrLaptop ? index < 4 : index < 4))
				.join(', ')
		: formatStates?.join(', ');

	const statesToModal = moreThanFive ? formatStates?.slice() : [];

	return {
		statesToList,
		statesToModal,
	};
};
